<template>
  <div>
    <h2 class="imtil">基础信息</h2>
    <div class="wrap">
      <div class="masks"></div>
    
    <div class="basiccon">
    <el-form :inline="true" :model="form" label-width="120px" class="demo-form-inline">
  <el-form-item label="姓名">
    <el-input v-model="form.name" size="small" placeholder="姓名"></el-input>
  </el-form-item>
  <el-form-item label="性别">
    <el-input v-model="form.gender" size="small" placeholder="性别"></el-input>
  </el-form-item>
 
  <el-form-item label="民族">
    <el-input v-model="form.nation" size="small" placeholder="民族"></el-input>
  </el-form-item>
  <el-form-item label="身份证号">
    <el-input v-model="form.idcard" size="small" placeholder="身份证号"></el-input>
  </el-form-item>
    <el-form-item label="出生日期">
    <el-input v-model="form.birthday" size="small" placeholder="出生日期"></el-input>
  </el-form-item>
  
  <el-form-item label="手机号码">
    <el-input v-model="form.tel" size="small" placeholder="手机号码"></el-input>
  </el-form-item>
  <el-form-item label="政治面貌">
    <el-input v-model="form.politicalLandscape" size="small" placeholder="政治面貌"></el-input>
  </el-form-item>
  <el-form-item label="健康状况">
    <el-input v-model="form.health" size="small" placeholder="健康状况"></el-input>
  </el-form-item>
  <el-form-item label="原工作单位">
    <el-input v-model="form.originalWorkUnit" size="small" placeholder="原工作单位"></el-input>
  </el-form-item>
  <el-form-item label="原任职务">
    <el-input v-model="form.originalPosition" size="small" placeholder="原任职务"></el-input>
  </el-form-item>
  <el-form-item label="退休年月">
    <el-input v-model="form.retiredDate" size="small" placeholder="退休年月"></el-input>
  </el-form-item>
  
   <el-form-item label="文化程度">
    <el-input v-model="form.educationLevel" size="small" placeholder="文化程度"></el-input>
  </el-form-item>
  <el-form-item label="档案存放地点">
    <el-input v-model="form.archivesAddress" size="small" placeholder="档案存放地点"></el-input>
  </el-form-item>
  <el-form-item label="特长">
    <el-input v-model="form.specialty" size="small" placeholder="特长"></el-input>
  </el-form-item>
  <el-form-item label="参加工作时间">
    <el-input v-model="form.enterServiceDate" size="small" placeholder="参加工作时间"></el-input>
  </el-form-item>
  <el-form-item label="爱好">
    <el-input v-model="form.hobbies" size="small" placeholder="爱好"></el-input>
  </el-form-item>
   <el-form-item label="特殊人员情况">
    <el-input v-model="form.specialCase" size="small" placeholder="特殊人员情况"></el-input>
  </el-form-item>
   <el-form-item label="备注">
    <el-input  v-model="form.remark" size="small" placeholder="备注"></el-input>
  </el-form-item>
</el-form>
</div>
  <h2 class="imtil">参保情况</h2>
  
    <el-form :inline="true" :model="form" class="demo-form-inline"> 
    <el-form-item label="社会保险关系所在地">
    <el-input  v-model="form.socialSecurityAddress" style="width:280px" size="small" placeholder="社会保险关系所在地"></el-input>
  </el-form-item>  
  
   <el-form-item label="社会保障号码">
    <el-input v-model="form.socialSecurityNo" size="small" placeholder="社会保障号码"></el-input>
  </el-form-item>
    <el-form-item label="参保类别">
    <el-input v-model="form.socialSecurityType" size="small" placeholder="参保类别"></el-input>
  </el-form-item>
  <el-form-item label="移交地县（市、区）">
    <el-input v-model="form.formshiftAddress" style="width:280px" size="small" placeholder="移交地县（市、区）"></el-input>
  </el-form-item>
  </el-form>
   <el-form :inline="true" :model="form" class="demo-form-inline"> 
<el-form-item label="现居住地址">
    <el-input v-model="form.nowAddress" style="width:280px" size="small" placeholder="现居住地址"></el-input>
  </el-form-item>  
 
   <el-form-item label="户口所在地">
    <el-input v-model="form.registAddress" style="width:280px" size="small" placeholder="户口所在地"></el-input>
  </el-form-item> 
   <el-form-item label="参保类别">
       <el-input v-model="form.socialSecurityType" size="small" placeholder="参保类别"></el-input>
  </el-form-item>
  </el-form>
  <h2 class="imtil">家庭成员</h2>
    <el-form :inline="true" :model="form" class="demo-form-inline">   
   <el-form-item label="姓名">
    <el-input v-model="form.kinsfolkName" size="small" placeholder="姓名"></el-input>
  </el-form-item>
  <el-form-item label="关系">
    <el-input v-model="form.kinsfolkRelation" size="small" placeholder="关系"></el-input>
  </el-form-item>
  <el-form-item label="工作单位">
    <el-input v-model="form.kinsfolkWorkUnit" size="small" placeholder="工作单位"></el-input>
  </el-form-item>
  <el-form-item label="联系电话">
    <el-input v-model="form.kinsfolkTel" size="small" placeholder="联系电话"></el-input>
  </el-form-item>
  <el-form-item label="详细地址">
    <el-input v-model="form.kinsfolkAddrees" style="width:280px" size="small" placeholder="详细地址"></el-input>
  </el-form-item>
  <!-- <el-form-item label="邮政编码">
    <el-input v-model="yzcode1" size="small" placeholder="邮政编码"></el-input>
  </el-form-item> -->
  <hr style='background-color:lightgray; height:1px; border:none;'>
  <el-form-item label="姓名">
    <el-input v-model="form.kinsfolkNameBak" size="small" placeholder="姓名"></el-input>
  </el-form-item>
  <el-form-item label="关系">
    <el-input v-model="form.kinsfolkRelationBak" size="small" placeholder="关系"></el-input>
  </el-form-item>
  <el-form-item label="工作单位">
    <el-input v-model="form.kinsfolkWorkUnitBak" size="small" placeholder="工作单位"></el-input>
  </el-form-item>
  <el-form-item label="联系电话">
    <el-input v-model="form.kinsfolkTelBak" size="small" placeholder="联系电话"></el-input>
  </el-form-item>
    <el-form-item label="详细地址">
    <el-input v-model="form.kinsfolkAddreesBak" size="small" style="width:280px" placeholder="详细地址"></el-input>
  </el-form-item>
  <!-- <el-form-item label="邮政编码">
    <el-input v-model="form.yzcode2" size="small" placeholder="邮政编码"></el-input>
  </el-form-item> -->
  </el-form>
   </div>
   <div class="imgcon">
       <div class="igc" v-for="(item,index) in form.images" :key="index">
           <div class="imgtil">{{item.imageType}}</div>
           <img :src="ossurl+item.imageUrl" alt="">
       </div>
   </div>
   
  </div>
</template>
<script>
    import CryptoJS from 'crypto-js'
    import { Loading } from 'element-ui';
    const ossurl = 'http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/'
    export default {
        data(){
            return{
                activeNames: ['1'],
                form:{
                    
                },
                ossurl:'http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/',
                urls: [

                ],
            
            }

        },
        methods:{
           
           
            decrypt(word){
                var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
                var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
                return CryptoJS.enc.Utf8.stringify(decrypt).toString();
            }

        },
        created(){

            this.activities=JSON.parse(sessionStorage.getItem("progress"))
            // if(this.$route.query.info){
            //     sessionStorage.setItem("info",this.$route.query.info)
            // }

            //if(this.$route.query.info){
                var a=JSON.stringify(this.$route.query)
                sessionStorage.setItem("items",a)
           // }
           
            this.form =JSON.parse(sessionStorage.getItem("msginfo"))
            console.log(this.form)
            this.form.name=this.form.name
            this.form.idcard=this.form.idcard
            this.form.tel=this.form.tel
            this.form.formshiftAddress=this.form.shiftAddressProvice+this.form.shiftAddressCounty+this.form.shiftAddressCity+this.form.shiftAddressStreet+this.form.shiftAddressCommunity
            this.form.nowAddress=this.form.dwellAddressProvice+this.form.dwellAddressCounty+this.form.dwellAddressStreet+this.form.dwellAddressCommunity+this.form.dwellAddressNumber
            this.form.registAddress=this.form.registAddressProvice+this.form.registAddressCounty+this.form.registAddressCity+this.form.registAddressStreet+this.form.registAddressCommunity+this.form.registAddressNumber
            this.form.gender=this.form.gender==1?"男":'女'
            this.form.socialSecurityType=this.form.socialSecurityType==0?'养老':this.form.socialSecurityType==1?"医疗":"其他"
            this.form.kinsfolkTel=this.decrypt(this.form.kinsfolkTel)
             this.form.kinsfolkTelBak=this.decrypt(this.form.kinsfolkTelBak)
            //this.form.personPic = this.form.personPic?ossurl+this.form.personPic:null;
            //this.form.bankPic = this.form.bankPic?ossurl+this.form.bankPic:null;
            //this.form.regbookPic = this.form.regbookPic?ossurl+this.form.regbookPic:null;
            //this.form.idcardPic = this.form.idcardPic?ossurl+this.form.idcardPic:null;
            //this.form.guardianIdcardPic = this.form.guardianIdcardPic?ossurl+this.form.guardianIdcardPic:null;
        }

    }
</script>
<style>
.imgcon{
  overflow: hidden;
}
  .wrap{
    overflow: hidden;
    position: relative;
  }
  .imgcon{
      display: flex;
      flex-wrap:wrap
  }
  .igc{
      width: 20%;
      margin-left: 10px;
  }
  .igc img{
      width: 100%;
  }
  .imgtil{
      text-align: center;
      padding: 10px;
  }
  .tim{
    border: 1px solid lightgray;
    padding: 10px;
    width: 180px;
    position: fixed;
    right: 0;
    top: 30%;
    border-radius: 10px;
    background:#ffffff

  }
  .masks{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200
  }
  .forml{
    float: left;
    width: 45%
  }
  .formr{
    float: left;
    width: 40%;
    margin-left: 20px
  }
  .imgcon{
    margin: 0 auto;
    box-shadow: 0 0 15px lightgray;
    margin-bottom: 40px
  }
  .block{
    width: 20% !important;
    text-align: center;
    margin-left: 10px;
  }
  .block{
    float: left;
    height: 100%;
    margin-right: 20px
  }
  .imtil{
    padding:0 0 20px 0
  }
</style>



// WEBPACK FOOTER //
// src/views/shangCheng/msgInfo.vue